import React from 'react';
import PropTypes from 'prop-types';
import { Box, Media } from '@honda-canada/design-system-react';

import DesktopLayout from '../DesktopLayout';
import MobileLayout from '../MobileLayout';
import isSSR from '../../utils/isSSR';
import { DealersListProvider } from '../DealersListContext';
import { GoogleMapRefProvider } from '../GoogleMapRefContext';
import { VariantProvider } from '../../context/VariantContext';
import { ConfigurationProvider } from '../../context/ConfigurationContext';
import { JSSComponentProvider } from '../../context/JSSComponentContext';

const DealerLocator = jssComponentProps => {
  if (isSSR()) return null;

  return (
    <JSSComponentProvider {...jssComponentProps}>
      <VariantProvider>
        <ConfigurationProvider>
          <DealersListProvider>
            <GoogleMapRefProvider>
              <Box>
                <Media greaterThanOrEqual="desktop">
                  <DesktopLayout />
                </Media>
                <Media lessThan="desktop">
                  <MobileLayout />
                </Media>
              </Box>
            </GoogleMapRefProvider>
          </DealersListProvider>
        </ConfigurationProvider>
      </VariantProvider>
    </JSSComponentProvider>
  );
};

DealerLocator.propTypes = {
  fields: PropTypes.shape({}),
  componentName: PropTypes.string,
  SubAppTitleComponent: PropTypes.func,
  DealerCardComponent: PropTypes.func,
  DisclaimerComponent: PropTypes.func,
};

export default DealerLocator;
